import React, { useState, useEffect } from "react";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";

import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import dayjs from "dayjs";
import CountUp from "react-countup";
import { getDashboardSummary, getDashboardSummaryExpire } from "../../helpers/backend_helper";

const Dashboard = () => {
  document.title = "Inicio | Sistema de Logística";

  const [loading, setLoading] = useState(true);
  const [dashboardSummary, setDashboardSummary] = useState();
  const [dashboardSummaryExpires, setDashboardSummaryExpires] = useState();

  const lastUpdate = dashboardSummary?.created_at
    ? dayjs(dashboardSummary.created_at).format("DD MMM YYYY H:mm")
    : null;

  const fetchDashboardSummary = () => {
    getDashboardSummary()
      .then(setDashboardSummary)
      .finally(() => {
        setLoading(false);
      });

    getDashboardSummaryExpire()
      .then(setDashboardSummaryExpires)
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(fetchDashboardSummary, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Dashboard" breadcrumbItem="Dashboard" />

          {lastUpdate && (
            <div className="text-end pb-3">
              <span>
                Última actualización <strong>{lastUpdate}</strong>
              </span>
            </div>
          )}

          <Row>
            <Col xl="12">
              {loading && (
                <div className="text-center">
                  <Spinner color="primary" className="spinner-lg" />
                </div>
              )}
            </Col>
            <Col xl={3} md={6}>
              <Card className="card-h-100">
                <CardBody>
                  <Row className="align-items-center">
                    <Col xs={12}>
                      <span className="text-muted mb-3 lh-1 d-block text-truncate">
                        Total Salidas
                      </span>
                      <h4 className="mb-3">
                        <span className="counter-value">
                          <CountUp
                            start={0}
                            end={dashboardSummary?.total_departures}
                            duration={5}
                          />
                        </span>
                      </h4>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} md={6}>
              <Card className="card-h-100">
                <CardBody>
                  <Row className="align-items-center">
                    <Col xs={12}>
                      <span className="text-muted mb-3 lh-1 d-block text-truncate">
                        Total pasajeros
                      </span>
                      <h4 className="mb-3">
                        <span className="counter-value">
                          <CountUp
                            start={0}
                            end={dashboardSummary?.total_passengers}
                            duration={5}
                          />
                        </span>
                      </h4>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} md={6}>
              <Card className="card-h-100">
                <CardBody>
                  <Row className="align-items-center">
                    <Col xs={12}>
                      <span className="text-muted mb-3 lh-1 d-block text-truncate">
                        Venta combustible
                      </span>
                      <h4 className="mb-3">
                        <span className="counter-value">
                          <CountUp
                            start={0}
                            end={dashboardSummary?.total_fuel}
                            duration={5}
                          />{" "}
                        </span>
                        Litros
                      </h4>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col xl={3} md={6}>
              <Card className="card-h-100">
                <CardBody>
                  <Row className="align-items-center">
                    <Col xs={12}>
                      <span className="text-muted mb-3 lh-1 d-block text-truncate">
                        Ocupación general
                      </span>
                      <h4 className="mb-3">
                        <span className="counter-value">
                          <CountUp start={0} end={0} duration={12} />%
                        </span>
                      </h4>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody className="p-0">
                  <Table color="primary" className={""}>
                    <thead className="bg-light">
                      <tr>
                        <th width="40%"></th>
                        <th className="text-center" width="30%">
                          Unidad
                        </th>
                        <th className="text-center" width="30%">
                          Operador
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="fw-bold">
                          <i className="fa fa-users me-2"></i> Pasajeros
                          <span className="text-muted"> (día de hoy)</span>
                        </td>
                        <td className="text-center">
                          <div className="d-inline-block text-start">
                            <span className="text-primary">
                              <i className="fa fa-angle-up me-2"></i>
                              <b>
                                {dashboardSummary?.max_unit_passengers || "-"}
                              </b>
                            </span>
                            <br />
                            <span className="text-muted">
                              <i className="fa fa-angle-down me-2"></i>
                              <b>
                                {dashboardSummary?.min_unit_passengers || "-"}
                              </b>
                            </span>
                          </div>
                        </td>
                        <td className="text-start">
                          <div className="d-inline-block text-start">
                            <span className="text-primary">
                              <i className="fa fa-angle-up me-2"></i>
                              <b>
                                {dashboardSummary?.max_operator_passengers ||
                                  "-"}
                              </b>
                            </span>
                            <br />
                            <span className="text-muted">
                              <i className="fa fa-angle-down me-2"></i>
                              <b>
                                {dashboardSummary?.min_operator_passengers ||
                                  "-"}
                              </b>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="fw-bold">
                          <i className="fa fa-fire-alt me-2"></i> Quemadas
                          <span className="text-muted"> (día de hoy)</span>
                        </td>
                        <td className="text-center">
                          <div className="d-inline-block text-start">
                            <span className="text-primary">
                              <i className="fa fa-angle-up me-2"></i>
                              <b>
                                {dashboardSummary?.max_unit_minutes_burned ||
                                  "-"}
                              </b>
                            </span>
                            <br />
                            <span className="text-muted">
                              <i className="fa fa-angle-down me-2"></i>
                              <b>
                                {dashboardSummary?.min_unit_minutes_burned ||
                                  "-"}
                              </b>
                            </span>
                          </div>
                        </td>
                        <td className="text-start">
                          <div className="d-inline-block text-start">
                            <span className="text-primary">
                              <i className="fa fa-angle-up me-2"></i>
                              <b>
                                {dashboardSummary?.max_operator_minutes_burned ||
                                  "-"}
                              </b>
                            </span>
                            <br />
                            <span className="text-muted">
                              <i className="fa fa-angle-down me-2"></i>
                              <b>
                                {dashboardSummary?.min_operator_minutes_burned ||
                                  "-"}
                              </b>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="fw-bold">
                          <i className="fa fa-sync-alt me-2"></i> Vueltas
                          <span className="text-muted"> (día de hoy)</span>
                        </td>
                        <td className="text-center">
                          <div className="d-inline-block text-start">
                            <span className="text-primary">
                              <i className="fa fa-angle-up me-2"></i>
                              <b>
                                {dashboardSummary?.max_unit_departures || "-"}
                              </b>
                            </span>
                            <br />
                            <span className="text-muted">
                              <i className="fa fa-angle-down me-2"></i>
                              <b>
                                {dashboardSummary?.min_unit_departures || "-"}
                              </b>
                            </span>
                          </div>
                        </td>
                        <td className="text-start">
                          <div className="d-inline-block text-start">
                            <span className="text-primary">
                              <i className="fa fa-angle-up me-2"></i>
                              <b>
                                {dashboardSummary?.max_operator_departures ||
                                  "-"}
                              </b>
                            </span>
                            <br />
                            <span className="text-muted">
                              <i className="fa fa-angle-down me-2"></i>
                              <b>
                                {dashboardSummary?.min_operator_departures ||
                                  "-"}
                              </b>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="fw-bold">
                          <i className="fa fa-moon me-2"></i> Veladas
                          <span className="text-muted"> (semana actual)</span>
                        </td>
                        <td className="text-center">
                          <div className="d-inline-block text-start">
                            <span className="text-primary">
                              <i className="fa fa-angle-up me-2"></i>
                              <b>{dashboardSummary?.max_unit_veladas || "-"}</b>
                            </span>
                            <br />
                            <span className="text-muted">
                              <i className="fa fa-angle-down me-2"></i>
                              <b>{dashboardSummary?.min_unit_veladas || "-"}</b>
                            </span>
                          </div>
                        </td>
                        <td className="text-start">
                          <div className="d-inline-block text-start">
                            <span className="text-primary">
                              <i className="fa fa-angle-up me-2"></i>
                              <b>
                                {dashboardSummary?.max_operator_veladas || "-"}
                              </b>
                            </span>
                            <br />
                            <span className="text-muted">
                              <i className="fa fa-angle-down me-2"></i>
                              <b>
                                {dashboardSummary?.min_operator_veladas || "-"}
                              </b>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td className="fw-bold">
                          <i className="fa fa-user-check me-2"></i> Asistencias
                          <span className="text-muted"> (semana actual)</span>
                        </td>
                        <td className="text-center">
                          <div className="d-inline-block text-start">
                            <span className="text-primary">
                              <i className="fa fa-angle-up me-2"></i>
                              <b>
                                {dashboardSummary?.max_unit_attendances || "-"}
                              </b>
                            </span>
                            <br />
                            <span className="text-muted">
                              <i className="fa fa-angle-down me-2"></i>
                              <b>
                                {dashboardSummary?.min_unit_attendances || "-"}
                              </b>
                            </span>
                          </div>
                        </td>
                        <td className="text-start">
                          <div className="d-inline-block text-start">
                            <span className="text-primary">
                              <i className="fa fa-angle-up me-2"></i>
                              <b>
                                {dashboardSummary?.max_operator_attendances ||
                                  "-"}
                              </b>
                            </span>
                            <br />
                            <span className="text-muted">
                              <i className="fa fa-angle-down me-2"></i>
                              <b>
                                {dashboardSummary?.min_operator_attendances ||
                                  "-"}
                              </b>
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Container fluid>
          <Card>
            <CardBody className={"p-0"}>
              <Table color="primary" className={""}>
                <thead className="bg-light">
                  <tr>
                    <th></th>
                    <th className="text-center">Seguro de Unidades</th>
                    <th className="text-center" >
                      Verificación de unidades
                    </th>
                    <th className="text-center" >
                      Licencia de operadores
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>
                      Vencidos
                    </th>
                    <td className="text-center text-danger fw-bold">
                      {dashboardSummaryExpires?.seguro?.vencidos ?? '-'}<br />

                    </td>
                    <td className="text-center text-danger fw-bold" >
                      {dashboardSummaryExpires?.verificacion?.vencidos ?? '-'}<br />
                    </td>
                    <td className="text-center text-danger fw-bold" >
                      {dashboardSummaryExpires?.licencia?.vencidos ?? '-'}<br />
                    </td>
                  </tr>
                  <tr>
                    <th>
                      Vencen en los siguientes 30 días:
                    </th>
                    <td className="text-center text-warning fw-bold">
                      {dashboardSummaryExpires?.seguro?.por_vencer ?? '-'}
                    </td>
                    <td className="text-center text-warning fw-bold" >
                      {dashboardSummaryExpires?.verificacion?.por_vencer ?? '-'}
                    </td>
                    <td className="text-center text-warning fw-bold" >
                      {dashboardSummaryExpires?.licencia?.por_vencer ?? '-'}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default Dashboard;
